export default "__VITE_ASSET__be486d8c__"